import React from "react"
import { graphql } from "gatsby"
import { Link } from "gatsby"
// import { Link } from "gatsby"
//import Layout from "../components/layout"
// import SEO from "../components/seo"
import {default as SeoComponent} from "../components/seo"
// import PostHeaderMeta from "../components/post-header-meta"
// import PostFooterMeta from "../components/post-footer-meta"
//import AniLink from "gatsby-plugin-transition-link/AniLink"
// import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { navigate } from "gatsby";
// import { window, document } from 'browser-monads';
import SharePanel from "../components/share"
// import { useState, useEffect, useLayoutEffect } from 'react'
import styled from 'styled-components'
import moment from "moment/moment"
import { UrlsUtils } from "../utils/UrlsUtils";

// var regStr = 'http[s]*://(?!cdn)[a-z0-9A-Z.]*'+process.env.GATSBY_WPHOST+'/';
// var reg = new RegExp(regStr,"g");

const DivAnnounce = styled.div`
  box-sizing: border-box;
  border: 2px solid #E7E7E7;
  border-radius: 10px;
  width:316px;
  max-width:100%;
  height: 404px;
  margin: auto;
  position: relative;
  overflow:hidden
`

const ButtonNM = styled.div`
 border-radius: 7px;
 height: 52px;
width: 142px;
line-height: 52px;
   background: linear-gradient(53.35deg, #EE3D49 0%, #CB356B 100%);
  color: #FFFFFF;
  font-family: "aktiv-grotesk";
  font-size: 19px;
  font-weight: 800;
  letter-spacing: 0.69px;
  text-align: center;
`


export const query = graphql`
  query BandiPageQuery {
    site {
      siteMetadata {
        title
      }
    }
    www {
      announcements(
        where: {
          isAvaiableAnnouncement: true,
          orderby: { field: DATE, order: DESC }
          status: PUBLISH
        }
        first: 12
      ) {
        nodes {
          id
          title
          excerpt
          uri
          link
          date
          content
          opening
          closing
          external_link
          price
          featuredImage {
            node {
              link
              mediaItemUrl
            }
          }
          categories {
            nodes {
              name
              slug
            }
          }
          tags {
            nodes {
              slug
              name
            }
          }
        }
      }
    }
  }
`

function isNumeric(str) {
  if (typeof str != "string") return false;
  return !isNaN(str) && !isNaN(parseFloat(str))
}

const IndexPage = ({ data }) => {
  data.www.announcements &&
    data.www.announcements.nodes.sort(function (a, b) {
      var keyA = moment(a.closing).toDate(),
        keyB = moment(b.closing).toDate()

      if (keyA < keyB) return -1
      if (keyA > keyB) return 1

      return 0
    })

  return (<div className="newmag-single-article">
    <SharePanel display="none"/>
    <SeoComponent title={"Bandi"} description={""} />
    <div style={{background: "rgba(11,1,53,0.76)", backgroundPosition: 'center', backgroundSize: 'cover', backgroundImage: 'url("/img/bandi@2x.png")', marginLeft: "-4.7%", height: "310px", width: "110%"}}>
      <div className="bandi_title_desk" style={{color: "white", height: "135px",width: "557px", fontFamily: "aktiv-grotesk",fontSize: "108px",letterSpacing: "2.4px",lineHeight: "139px", fontWeight:"800", paddingLeft:"145px", paddingTop:"59px"}}>Bandi</div>
    </div>
    <div style={{background: "linear-gradient(53.35deg, #EE3D49 0%, #CB356B 100%)", marginLeft: "-4.7%", height: "89px", width: "110%"}}>
      <div style={{height: "135px",width: "557px", color: "#FFFFFF", fontFamily: "aktiv-grotesk",fontSize: "108px",letterSpacing: "2.4px",lineHeight: "139px", fontWeight:"800", paddingLeft:"82px", paddingTop:"59px"}}></div>
    </div>
    <div style={{background: "", marginLeft: "-4.7%", height: "72px", width: "110%"}}>
      <div style={{height: "135px",width: "557px", color: "#FFFFFF", fontFamily: "aktiv-grotesk",fontSize: "108px",letterSpacing: "2.4px",lineHeight: "139px", fontWeight:"800", paddingLeft:"82px", paddingTop:"59px"}}></div>
    </div>

    <article
      className={`newmag-article post-bandi post type-post status-publish format-standard hentry category-react tag-accessibility tag-gatsby entry`}
    >
      <div style={{display: "none", width: "100%", height: "80px"}}><div style={{float:"right"}}>ORDINA PER <b style={{marginLeft:"20px"}}>Data di scadenza</b> <span style={{paddingTop: "30px", fontSize:"18px"}}>v</span></div></div>
      <div id="article_list" style={{marginBottom: "200px",display:'grid',gridTemplateColumns: 'repeat(auto-fill, minmax(310px, 1fr))', gridGap: '28px'}}>

    {data.www.announcements.nodes
      .map(announce => (
        <DivAnnounce className="mag_announcement"
          key={UrlsUtils.ensure_wp_admin_url(announce.link)}
          to={UrlsUtils.ensure_wp_admin_url(announce.link)}
          rel="link"
        >
          <Link to={UrlsUtils.ensure_wp_admin_url(announce.link)}>
            <div style={{
                height:'164px',
                width:'100%',
                backgroundPosition:'center',
                backgroundSize:'cover',
                backgroundImage:"url(" + (
                  (
                    announce.featuredImage &&
                    announce.featuredImage.node &&
                    announce.featuredImage.node.mediaItemUrl
                  )?
                announce.featuredImage.node.mediaItemUrl : "") + ")"
              }}
              >
            </div>
          </Link>
          <div style={{padding: '10px', display: "flex", flexDirection: "column", height: '235px', justifyContent: 'space-between'}}>
            <h2 style={{height:"100px",color: '#232323', fontFamily: "aktiv-grotesk", fontSize: '20px', letterSpacing: 0 ,lineHeight: '22px', fontWeight:"800"}}>{announce.title} </h2>
            <div style={{
                height: '12px',
                color: '#76778C',
                fontFamily: "urw-din",
                fontSize: '12px',
                fontWeight: 'bold',
                letterSpacing: '0.48px',
                lineHeight: '12px',
                paddingBottom: '2rem',
              }}>
              <b>{moment(announce.closing).locale('it').format(`D MMMM`)}</b>
            </div>
            <div style={{height:"52px", display: 'flex', justifyContent: 'space-between'}}>
              <div
                style={{
                  color: '#232323',
                  fontFamily: "aktiv-grotesk",
                  fontSize: '24px',
                  letterSpacing: '0',
                  lineHeight: '31px',
                  fontWeight: '800',
                  marginTop: 'auto',
                  marginBottom: 'auto',
                }}>
                  {isNumeric((announce.price || '').replace('€', '')) ? announce.price : ''}
              </div>
              <div style={{float: "right"}}>
                <Link to={UrlsUtils.ensure_wp_admin_url(announce.link)}>
                  <ButtonNM className="bandi-partecipa">Partecipa</ButtonNM>
                </Link>
              </div>
            </div>
          </div>
        </DivAnnounce>
      ))

/*
      data.www.announcements.nodes.map((announce) => {
      return
        <div className="post-list" key={announce.title}>
          <h1>{announce.title}</h1>

          <span>{announce ? announce.title : "empty"}</span>
          <p></p>
        </div>
    })
*/
  }
  </div>

</article>
</div>
)}
export default IndexPage
